export default __webpack_public_path__ + "static/pandagroup_landing-90c36b34e4d00ed8c00382eb71d23aa7.png";